var $e336e240a08943c4$exports = {};
$e336e240a08943c4$exports = {
    "colorFormat": `Format boja`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$e336e240a08943c4$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
